"use client";

import React from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import DocumentPreview from "../../../consultation/components/AddNewConsultationPopup/DocumentPreview/DocumentPreview";

import "./Prescriptionmodal.css";

const PrescriptionModal = ({ open, onClose, prescriptionData, layout }) => {
  const { t } = useTranslation();

  const handlePrint = () => {
    window.print();
  };

  const doctor = prescriptionData?.doctor || {};
  const documentType = prescriptionData?.type || "Prescription";
  const content = String(prescriptionData?.content || "");
  const template = prescriptionData?.layout || prescriptionData?._original || {};
  const logo = template.logoUrl || template.logo_url || layout?.logoUrl || layout?.logo || doctor.logoUrl || null;
  const textColor = template.couleurTexte || template.couleur_texte || layout?.couleurTexte || "#17233b";
  const logoColor = template.couleurLogo || template.couleur_logo || layout?.couleurLogo || "#1677ed";
  const fullName = template.fullName || template.full_name || doctor.fullName || doctor.name || "Doctor";
  const fullNameAr = template.fullNameAr || template.full_name_ar || "";
  const specialty = template.specialty || doctor.specialty || "";
  const specialtyAr = template.specialtyAr || template.specialty_ar || "";
  const phone = template.phone || doctor.phone || "";
  const email = template.email || doctor.email || "";
  const address = template.address || template.clinicAddress || doctor.clinicAddress || doctor.address || "";
  const addressAr = template.addressAr || template.address_ar || "";

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      className="prescription-modal"
      centered
      destroyOnClose
    >
      {prescriptionData ? (
        <div className="patient-document-view">
          <DocumentPreview
            standalone
            prescriptionContent={content}
            docKey={String(prescriptionData?.type || "prescription").toLowerCase()}
            generatedDocuments={[{
              id: prescriptionData.id || "patient-document",
              type: String(prescriptionData?.type || "prescription").toLowerCase(),
              content,
            }]}
            activeGeneratedDocumentId={prescriptionData.id || "patient-document"}
            doctorData={doctor}
            layout={template}
          />
        </div>
      ) : (
        <div className="prescription-modal-loading">
          {t("prescriptionModal.loading")}
        </div>
      )}
    </Modal>
  );
};

export default PrescriptionModal;